import React from "react";
import { NavLink } from "react-router-dom";
import { FaUserMd, FaCalendarAlt } from "react-icons/fa";
import { MdEventAvailable } from "react-icons/md";

const DoctorSidebar = () => {
  const links = [
    {
      key: "dashboard",
      label: "Dashboard",
      icon: <FaCalendarAlt size={22} />,
      to: "/doctor/dashboard",
    },
    {
      key: "portfolio",
      label: "My Portfolio",
      icon: <FaUserMd size={22} />,
      to: "/doctor/profile",
    },
    { key: "profile",
       label: "Manage Slots",
        icon: <MdEventAvailable size={22} />,
         to: "/doctor/face" 
        }
  ];

  return (
    <>
      <aside className="sidebar" role="navigation" aria-label="Doctor Sidebar Navigation">
        <div className="sidebar-header">
          <div className="avatar-circle" aria-hidden="true">
            <FaUserMd size={40} />
          </div>
          <h2>Doctor Panel</h2>
        </div>

       <nav className="sidebar-nav">
  {links.map(({ key, label, icon, to }) => (
    <NavLink
      key={key}
      to={to}
      className={({ isActive }) =>
        isActive ? "sidebar-link active" : "sidebar-link"
      }
      aria-current={({ isActive }) => (isActive ? "page" : undefined)}
      tabIndex={0}
    >
      <span className="sidebar-icon">{icon}</span>
      <span className="sidebar-text">{label}</span>
      <span className="active-indicator" />
    </NavLink>
  ))}
</nav>
      </aside>

   <style>{`
  .sidebar {
    width: 260px;
    min-height: 100vh;
    background: linear-gradient(160deg, #e6fff2, #e1f3ff);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
    border-radius: 0 30px 30px 0;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
  }

  .sidebar-header {
    text-align: center;
    margin-bottom: 40px;
    color: #256d85;
  }

  .avatar-circle {
    width: 80px;
    height: 80px;
    margin: 0 auto 12px;
    background: #ffffff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
  }

  .avatar-circle:hover {
    box-shadow: inset 4px 4px 12px rgba(0, 0, 0, 0.05), inset -4px -4px 12px #ffffff;
  }

  .sidebar-header h2 {
    font-weight: 700;
    font-size: 24px;
    letter-spacing: 1px;
  }

  .sidebar-nav {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .sidebar-link {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 20px;
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    border-radius: 14px;
    text-decoration: none;
    background: #ffffff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
    transition: all 0.25s ease;
  }

  .sidebar-link:hover {
    background: linear-gradient(135deg, #c2fbd7 0%, #f0faff 100%);
    color: #00796b;
    transform: translateX(3px);
  }

  .sidebar-link .sidebar-icon {
    color: #00b894;
    display: flex;
    justify-content: center;
    transition: color 0.3s ease;
  }

  .sidebar-link:hover .sidebar-icon {
    color: #00796b;
  }

  .sidebar-link.active {
    background: linear-gradient(135deg, #a7ffeb, #c8e6ff);
    color: #00796b;
    box-shadow: inset 0 0 8px rgba(0, 121, 107, 0.2);
    font-weight: 700;
  }

  .sidebar-link.active .sidebar-icon {
    color: #00796b;
  }

  .active-indicator {
    position: absolute;
    left: -8px;
    top: 50%;
    transform: translateY(-50%);
    height: 60%;
    width: 6px;
    background-color: #00796b;
    border-radius: 10px;
    box-shadow: 0 0 8px #00796b;
    opacity: 0;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .sidebar-link.active .active-indicator {
    opacity: 1;
    transform: translateY(-50%) scaleY(1.1);
  }
`}</style>


    </>
  );
};

export default DoctorSidebar;
